<template>
    <div class="saas-page linear-page">
        <section class="linear-hero">
            <div>
                <p class="linear-kicker">
                    <router-link to="/home">Home</router-link>
                    <span>/</span>
                    <span>Blank</span>
                </p>
                <h1>Blank</h1>
                <p class="linear-copy">A quiet command surface reserved for future admin content.</p>
            </div>
            <div class="linear-command-card">
                <span class="linear-dot"></span>
                <span>Ready for content</span>
                <kbd>Empty</kbd>
            </div>
        </section>

        <section class="linear-empty" role="status">
            <div class="linear-empty__icon" aria-hidden="true">
                <admin-icon name="file"></admin-icon>
            </div>
            <span class="linear-label">Workspace</span>
            <h2>Blank page</h2>
            <p>This page is ready for content. Add modules, forms, or operational context when the workflow is defined.</p>
            <router-link to="/home" class="btn btn-sm admin-toolbar-btn admin-toolbar-btn--outline">Back to home</router-link>
        </section>
    </div>
</template>

<script>
    export default {
        methods: {
        },
        data() {
            return {
            }
        }
    }
</script>

<style scoped>
.linear-page {
    color: #111318;
}

.linear-hero {
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(260px, 0.34fr);
    gap: 1.25rem;
    align-items: end;
    margin-bottom: 1rem;
}

.linear-kicker,
.linear-label {
    color: #625cf6;
    font-size: 0.6875rem;
    font-weight: 800;
    letter-spacing: 0.08em;
    text-transform: uppercase;
}

.linear-kicker {
    display: flex;
    gap: 0.45rem;
    margin-bottom: 0.65rem;
}

.linear-hero h1 {
    margin: 0;
    font-size: clamp(2rem, 4vw, 3rem);
    font-weight: 800;
    letter-spacing: -0.055em;
}

.linear-copy {
    max-width: 42rem;
    margin: 0.75rem 0 0;
    color: #687083;
    line-height: 1.65;
}

.linear-command-card,
.linear-empty {
    border: 1px solid #e5e8ef;
    border-radius: 18px;
    background: rgba(255, 255, 255, 0.9);
    box-shadow: 0 16px 48px rgba(31, 35, 48, 0.04), inset 0 1px 0 rgba(255, 255, 255, 0.86);
}

.linear-command-card {
    display: flex;
    align-items: center;
    gap: 0.65rem;
    min-height: 3.2rem;
    padding: 0.5rem 0.85rem;
    color: #687083;
    font-weight: 600;
}

.linear-command-card kbd {
    margin-left: auto;
    border: 1px solid #e5e8ef;
    border-radius: 7px;
    color: #8b93a7;
    background: #fff;
}

.linear-dot {
    width: 0.5rem;
    height: 0.5rem;
    border-radius: 999px;
    background: #625cf6;
    box-shadow: 0 0 0 4px rgba(98, 92, 246, 0.1);
}

.linear-empty {
    display: grid;
    justify-items: center;
    min-height: 360px;
    padding: 3rem 1.25rem;
    text-align: center;
}

.linear-empty__icon {
    display: grid;
    width: 4.5rem;
    height: 4.5rem;
    place-items: center;
    margin-bottom: 1rem;
    border: 1px solid rgba(98, 92, 246, 0.18);
    border-radius: 20px;
    color: #625cf6;
    background: #eff0ff;
}

.linear-empty h2 {
    margin: 0.45rem 0 0;
    font-size: 1.25rem;
    font-weight: 800;
    letter-spacing: -0.03em;
}

.linear-empty p {
    max-width: 31rem;
    margin: 0.75rem 0 1.15rem;
    color: #687083;
    line-height: 1.65;
}

@media (max-width: 991.98px) {
    .linear-hero {
        grid-template-columns: 1fr;
    }
}
</style>
